
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Raisoni Premier League</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raisoni-premier-league section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Raisoni Premier <span > League</span></h2>
        </div>

        <div class="row">
            <div class="col-md-7">
                <div class="widget_title inner-title">
                    <h4>RAISONI PREMIER LEAGUE <span class="small-sm"> – LIVE THE THRILL AND EXCITEMENT!</span></h4>
                </div>

                <div class="fide-chess-text">
                    <p>"No Dream is Ever Chased Alone"- Rahul Dravid</p>
                </div>
                <p>And, when one of the best cricketer quotes this you cannot not follow it.

                    We at the Raisoni Group of Institutions have in a little time frame reached milestones of success.
                    It is attributed to our diligent faculty, state-of-the-art facilities and the curriculum we are so
                    proud of. Indeed, the curriculum has been so designed that it includes the finest academics, the
                    best of the cultural activities and some of the most amazing events round the year. The event
                    includes the sports activities, the cultural acts, the technical events, the conferences, the
                    symposiums and the list continues.</p>
            </div>
            <div class="col-md-5">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rpl.webp" alt="GHRSCF"
                        class="w-100">
                </div>
            </div>


        </div>

        <div class="row">
            <div class="col-md-12">
                <p>We have round the year plans for our students to make sure they ingest the best of knowledge, stay
                    informed and avail entertainment. In a country like India, where Cricket is a religion, the Raisoni
                    Group of Institutions is happy to introduce the Raisoni Premier League.</p>
            </div>

            <div class="widget_title inner-title mt-3">
                <h4>WHAT IS RPL (RAISONI PREMIER LEAGUE)?</h4>
            </div>
            <ul class="list-style list-style1">
                <li>The RPL involved auction of players</li>
                <li>Faculty members are owners of teams.</li>
                <li>The RPL involves a series of cricket matches.</li>
                <li>There are 14 teams playing for the winning title.</li>
                <li>It is a weeklong championship organized by G H Raisoni College of Commerce Science & Technology</li>

            </ul>

            <div class="widget_title inner-title mt-3">
                <h4>WHAT DOES IT INCLUDE?</h4>
            </div>
            <ul class="list-style list-style1">
                <li>There are in total 14 teams involved in the league.</li>
                <li>There are 12 boys’ team and 2 girls’ team.</li>
                <li>The teams include
                    <div class="row row-cols-1 row-cols-lg-2">
                        <div class="col">
                            <ul class="list-no">
                                <li>Leaping Leopard</li>
                                <li>Lion The King.</li>
                                <li>Classy Cats</li>
                                <li>Dashing Dolphin</li>
                                <li>Thundering Ducks</li>
                                <li>Pink Panther</li>
                                <li>Royal Eagles</li>
                            </ul>
                        </div>
                        <div class="col">
                            <ul class="list-no">
                                <li>Python Crushers</li>
                                <li>Kool Kingfisher</li>
                                <li>Hustling horses</li>
                                <li>Fresher</li>
                                <li>Ragging bulls</li>
                                <li>Blasty blue whales</li>
                                <li>Tuscan Tigers</li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>The Dashing Dolphin and The Classy Cats are the 2 girls teams which gets to play the finals in the
                    Girls category.</li>
                <li>The Auctioning of the team mates is pursued before the onset of the league.</li>
                <li>Every team has an alumni student, 9 players of the Raisoni Group of Colleges and one player (From
                    school or college other than the RGI).</li>
                <li>The basis of the match is a league-cum-knockout basis.</li>
                <li>It includes a total of 22 leagues, 2 semifinals and 2 finals.</li>
                <li>The inaugural function, the closing ceremony and the prize distribution is graced by the cricket
                    celebrities.</li>
            </ul>

            <div class="widget_title inner-title mt-3">
                <h4>FOR THE STUDENTS</h4>
            </div>
            <ul class="list-style list-style1">
                <li>Playing- the most revered sports- cricket- in a cheering crowd.</li>
                <li>Participating- in one of the finest leagues matches in the Central India.</li>
                <li>Get acknowledged- for the best batsman, the best bowler and the best fielder.</li>
                <li>Availing- some of the most awesome prizes in the form of cash, trophies or both.</li>
                <li>Indulging- in adrenaline rush and lots of excitement.</li>
            </ul>

        </div>

        <div class="border-line-sm"></div>

        <div class="row  row-cols-1 row-cols-lg-3">
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2021<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href=" https://drive.google.com/drive/folders/1ktZdALRamG-JzDNK4I-tmhgOTTqqdOOI?usp=sharing "
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2020 Part-1 <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1rIvUfJ-KMlrmpL7f21tkFQES-YqPGKhY?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2020 Part-2<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href=" https://drive.google.com/drive/folders/1hVRBrYZ08mLU5KuV200ox0TxfkmlJoIM?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2019<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1AeiTY5-oVWn4BGDWZfKXCc2GR807gqTf?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2018 Part-1 <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1hlyhMSUYQY_D0NlQLKj04m6-A4sx_T0X?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2018 Part-2<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1Sexs74RrXy0b_hhBV12j3NetpKsb1YtO?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2018 Part-3 <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href=" https://drive.google.com/drive/folders/1Z1lJjVjZmxWueGQ8aoAnZ1EVxcOStJ6w?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2018 Part-4 <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1pplcDgm5rNVnhHLMsK9SV84YV2MB-mC2?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2017 <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1YU8V1PxJkI4K29s4jy8cuZzsZmiMHU7X?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2016 Part-1<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1ubrgCAj9M6Tz_S3jhKkCvyZoSoYzrPF8?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2016 Part-2 <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1mCeHK7yp_-FhAOCpllT1KVQ7hN6ms9YK?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2016 Part-3<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://drive.google.com/drive/folders/1heTCfKymPEgLWQw9BbmAXIWSw7kKy-kZ?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Raisoni Premier League 2014 <i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href=" https://drive.google.com/drive/folders/1KohbiV9bQNn6fOQdB9zJBgFApfd6O0r7?usp=sharing"
                            class="feature-read-more">
                            Read More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
